angular.module('washesRevenueDetail', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);



// WEBPACK FOOTER //
// ./src/app/washes-revenue-detail/washes-revenue-detail.module.js